import { Box, FlexBox, Stack } from '@ardoq/layout';
import { PathCollapsingRuleItem } from './PathCollapsingRuleItem';
import { SmallGhostButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { TraversalBuilderViewState } from '../types';
import { CollapsePathsCommands } from './collapsePathsCommands';
import { EditPathCollapsingRule } from './EditPathCollapsingRule';
import { t, type I18nLocale } from '@ardoq/i18n';

type CollapsePathsItemsProps = {
  pathCollapsingViewState: TraversalBuilderViewState['pathCollapsingViewState'];
  commands: CollapsePathsCommands;
  i18nLocale: I18nLocale;
};

const CollapsePathsItems = ({
  commands,
  pathCollapsingViewState: { rules, currentEditableRule },
  i18nLocale,
}: CollapsePathsItemsProps) => {
  return (
    <Box
      padding="medium"
      paddingBottom="large"
      className="wrapper"
      width="full"
    >
      <Stack as="ul" align="stretch" gap="medium">
        {rules.map(rule => {
          if (currentEditableRule?.referenceTypeId === rule.referenceTypeId) {
            return (
              <EditPathCollapsingRule
                key={rule.referenceTypeId}
                rule={currentEditableRule}
                commands={commands}
                i18nLocale={i18nLocale}
              />
            );
          }
          return (
            <PathCollapsingRuleItem
              key={rule.referenceTypeId}
              rule={rule}
              commands={commands}
              isEditingAnotherRule={Boolean(currentEditableRule)}
              i18nLocale={i18nLocale}
            />
          );
        })}
      </Stack>
      {!currentEditableRule && (
        <FlexBox justify="center">
          <SmallGhostButton onClick={commands.createPathCollapsingRule}>
            <Icon iconName={IconName.ADD_CIRCLE} />{' '}
            {t(
              i18nLocale,
              'viewpointBuilder:collapsePaths.collapseButton',
              'Collapse a path'
            )}
          </SmallGhostButton>
        </FlexBox>
      )}
    </Box>
  );
};

export { CollapsePathsItems };
